import { ApiRequestMeta, EmailAccountModel } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface EmailAccountContextType {
  emailAccount: EmailAccountModel | undefined;
  isConnected: boolean;
  connectGmailAccount: () => void;
  disconnectEmailAccount: (meta?: ApiRequestMeta) => Promise<void>;
  isDisconnectingEmailAccount: boolean;
}

export const EmailAccountContext =
  createContext<EmailAccountContextType | null>(null);
